import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  primaryKeyword,
  canonical,
}) => {
  if (!title) {
    return null;
  }

  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {primaryKeyword ? (
        <meta name="primary-keyword" content={primaryKeyword} />
      ) : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
    </Helmet>
  );
};

export default SEO;
